/**
  Description:
  import { translate } from '@/assets/js/translations/Translate'

  mixins: [ translate ]
**/

export const translate = {
  methods: {
    translate (location, name, filterType = null) {
      const lang = 'kr'
      let data
      let newName
      let oldName

      if (typeof name === 'string') {
        name = name.replace(/[(]/g, ' ')
        name = name.replace(/[)]/g, '')
        name = name.toLowerCase().replace(/[_]/g, ' ')
        oldName = name

        if (lang) {
          if (filterType) {
            name = this.$root.$options.filters[filterType](name)
            name = location[lang][name]
          }

          newName = oldName.split(' ').join('_')

          try {
            data = location[lang][newName]
          } catch (e) {
            data = oldName
          }

          if (typeof data === 'undefined') {
            data = name
          }
        } else {
          data = name
        }
      }

      return data
    }
  }
}

export default translate
